var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('SentimentKlineDay',{attrs:{"title":"市场情绪","subText":"节点把控","modal":"0"}}),_c('SentimentKlineDay',{attrs:{"title":"市场人气","subText":"参考节点","modal":"20"}}),_c('SentimentMarketHotDay',{attrs:{"zoom_start":"45"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }